import s from './Avatar.module.css';

export default function Avatar({ src, alt = '', size = 'md', verified = false, initials, ...rest }) {
  const cls = [s.avatar, s[size], verified ? s.verified : ''].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {src ? <img className={s.img} src={src} alt={alt} /> : (initials || '')}
    </span>
  );
}
